import { useMemo } from "react";
import clsx from "clsx";
import { NotificationStatus } from "@/domains/notification/constants/status";

type Props = React.SVGAttributes<SVGSVGElement> & {
  fillPercent: number;
  status: NotificationStatus;
};

export default function NotificationIndicator({
  status,
  fillPercent,
  className,
  ...restProps
}: Props) {
  const R = 15;
  const length = 2 * Math.PI * R;
  const dashoffset = length / 4;
  const onePercent = length / 100;

  const color = useMemo(() => {
    if (status === NotificationStatus.Success) return "#56FF70";
    if (status === NotificationStatus.Error) return "#FF4E4E";
    if (status === NotificationStatus.Info) return "#5A99FF";
    return "#FFFFFF";
  }, [status]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={clsx(className)}
      {...restProps}
    >
      <circle cx={20} cy={20} r={20} fill="#0F0F0F" fillOpacity={0.36} />
      <circle
        cx={20}
        cy={20}
        r={15}
        fill={color}
        fillOpacity={0.2}
        stroke={color}
        strokeWidth={3}
        opacity={0.5}
      />
      <circle
        cx={20}
        cy={20}
        r={15}
        stroke={color}
        strokeWidth={4}
        strokeLinecap="round"
        strokeDashoffset={dashoffset}
        strokeDasharray={`${onePercent * fillPercent} ${length - onePercent * fillPercent}`}
      />
    </svg>
  );
}
